import { Pipe, PipeTransform } from '@angular/core';
import {Empresa} from '../../models/empresa.interface';

@Pipe({
  name: 'nomeEmpresa'
})
export class NomeEmpresaPipe implements PipeTransform {

  transform(value: Empresa, ...args: unknown[]): unknown {
    return value == null ? '' : value.nomeFantasia ;
  }

}
